// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___3vACX","spin":"spin___34cFr"};